/**
 * Utilitários para gerenciamento do modo mock
 */

/**
 * Verifica se o modo mock está ativo
 */
export const isMockMode = (): boolean => {
  return process.env.REACT_APP_MOCK_DATA === 'true';
};

/**
 * Verifica se o pagamento está habilitado
 */
export const isPaymentEnabled = (): boolean => {
  return process.env.REACT_APP_ENABLE_PAYMENT === 'true';
};

/**
 * Simula delay de rede para tornar o mock mais realista
 */
export const mockDelay = (min: number = 300, max: number = 800): Promise<void> => {
  const delay = Math.random() * (max - min) + min;
  return new Promise(resolve => setTimeout(resolve, delay));
};

/**
 * Gera ID único para novos registros mock
 */
export const generateMockId = (): number => {
  return Math.floor(Math.random() * 1000000) + Date.now();
};

/**
 * Formata data para mock (formato ISO)
 */
export const formatMockDate = (date: Date): string => {
  return date.toISOString().split('T')[0];
};

/**
 * Gera código de voucher mock
 */
export const generateVoucherCode = (): string => {
  const year = new Date().getFullYear();
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let code = `JER${year}`;
  
  for (let i = 0; i < 6; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  
  return code;
};

/**
 * Simula resposta de erro para casos específicos
 */
export const mockError = (message: string, status: number = 400): never => {
  const error = new Error(message) as any;
  error.status = status;
  error.response = {
    status,
    data: { message }
  };
  throw error;
};

/**
 * Log para modo mock
 */
export const mockLog = (operation: string, data?: any): void => {
  if (isMockMode()) {
    console.log(`🎭 Mock ${operation}:`, data);
  }
};
